import Overlay from '@adsk/alloy-react-overlay';

export const PLACEMENTS = Overlay.PLACEMENTS;
